import angular from 'angular';
import { changePageTitle } from 'auth/actions/session.actions';
import EftAmountWidget from './eft-amount-widget-component';
import EftHistoryComponent from './components/eft-history-component';

export default angular
  .module('eft-amount-widget', [])
  .component('eftAmountWidget', new EftAmountWidget())
  .component('eftHistory', new EftHistoryComponent())
  .config([
    '$stateProvider',
    function configuration($stateProvider) {
      $stateProvider.state('eft-sales-history', {
        parent: 'arw',
        url: '/eft/history/:retailerNo?',
        template: '<eft-history></eft-history>',
        redirectTo: 'permissions-denied',
        params: {
          pageTitle: [
            '$ngRedux',
            'gettextCatalog',
            ($ngRedux, gettextCatalog) => {
              $ngRedux.dispatch(changePageTitle(gettextCatalog.getString('Invoice History')));
            },
          ],
        },
      });
    },
  ]);



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/eft-amount/eft-amount-widget-module.js